// Initialize button state
document.addEventListener("DOMContentLoaded", function () {
  const pageTopButton = document.getElementById("pageTopButton");
  pageTopButton.style.opacity = "0.5";
  pageTopButton.style.pointerEvents = "none";

  // Smooth scroll to top functionality
  document
    .getElementById("pageTopButton")
    .addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

  // Show/hide button based on scroll position
  window.addEventListener("scroll", function () {
    const pageTopButton = document.getElementById("pageTopButton");
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 200) {
      pageTopButton.style.opacity = "1";
      pageTopButton.style.pointerEvents = "auto";
    } else {
      pageTopButton.style.opacity = "0.5";
      pageTopButton.style.pointerEvents = "none";
    }
  });
});
